import { Navigate } from "react-router-dom";
import { useApplication } from "../context/ApplicationContext";

export function PermissionGate({ permission, any = [], children, fallback = null }) {
  const { permissionKeys } = useApplication();
  const allowed = permission ? permissionKeys.includes(permission) : any.some((key) => permissionKeys.includes(key));
  return allowed ? children : fallback;
}

export function LutionGate({ lution, children, fallback = null }) {
  const { lutionEntitlements } = useApplication();
  return lutionEntitlements.includes(lution) ? children : fallback;
}

export function RequireAccess({ lution, permission, any = [], children }) {
  const { permissionKeys, lutionEntitlements } = useApplication();
  const permissionAllowed = permission ? permissionKeys.includes(permission) : any.some((key) => permissionKeys.includes(key));
  // Shared capabilities (for example audit.read) intentionally have no Lution.
  // Requiring `includes(undefined)` made their registered routes silently redirect.
  const lutionAllowed = !lution || lutionEntitlements.includes(lution);
  if (!lutionAllowed || !permissionAllowed) return <Navigate to="/" replace />;
  return children;
}
